export const getDropData = (dragEndResult) => {
  const getPlacementObj = ({ droppableId, index }) => ({ index, rowId: droppableId });
  return {
    rowId: dragEndResult.draggableId,
    type: dragEndResult.type,
    from: getPlacementObj(dragEndResult.source),
    to: getPlacementObj(dragEndResult.destination),
  };
};
